module.exports = __webpack_public_path__ + "img/right.46e178eb.png";